import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

const OWL_LOGO = require('./assets/OwlTransparent.svg');

@customElement('imprint-page')
export class ImprintPage extends ChemistryLitElement {
  static override styles = css`
    :host {
      display: block;
      width: 100%;
    }
  `;

  private __stylesAlreadyApplied = false;

  override async _updateStyles() {
    if (this.__stylesAlreadyApplied) return;
    await super._updateStyles();
    this.__stylesAlreadyApplied = true;
  }

  override render() {
    return html`
      <div class="bg-white text-gray-900 font-inter min-h-[100svh] flex flex-col">
        <div
          class="fixed top-4 left-4 right-4 md:left-1/2 md:-translate-x-1/2 md:w-full md:max-w-5xl z-50 flex justify-center pointer-events-none"
        >
          <nav
            class="pointer-events-auto w-full bg-white/70 backdrop-blur-lg shadow-lg shadow-blue-900/5 border border-white/60 rounded-full px-6 py-3 flex items-center"
          >
            <a href="/" class="flex items-center space-x-3 hover:opacity-80 transition-opacity">
              <img src="${OWL_LOGO}" alt="Gradias Owl" class="w-8 h-8 object-contain" />
              <span class="text-xl font-poppins font-extrabold tracking-wide text-[#89B4D6] select-none">gradias</span>
            </a>
          </nav>
        </div>

        <main class="flex-1 container mx-auto px-6 pt-32 pb-20 max-w-2xl">
          <a
            href="/"
            class="inline-flex items-center text-[#5594CF] hover:text-[#3d7ab6] font-semibold mb-10 text-sm transition-colors"
          >
            &larr; Back to home
          </a>

          <h1 class="text-3xl font-extrabold text-slate-800 mb-10">Imprint</h1>

          <p class="text-gray-600 mb-6">Gradias is a service offered by:</p>

          <address class="not-italic text-gray-800 leading-8 text-base">
            <strong>NEW DIGITAL INTELLIGENCE GmbH</strong><br />
            Hohenstaufenring 55<br />
            50674 Cologne<br />
            Germany
          </address>

          <p class="text-gray-600 mt-6">Legal representative: Michael Burian</p>
        </main>

        <footer class="bg-slate-900 py-10 text-center text-sm text-slate-400">
          <p>&copy; 2026 gradias by NDI. Alle Rechte vorbehalten.</p>
        </footer>
      </div>
    `;
  }
}
